import * as CONSTANTS from './constants';
import {addRemoveArrayOperation,getInitSelectedFilters} from './../Utils';
export function getInitialState() {
  return {
    dataLoading: true,
    src: '',
    dest: '',
    src_id: '',
    dest_id: '',
    doj: '',
    rDoj: '',
    journeyType: 'onw',
    rawData: {},
    privateAvailableBuses: {},
    privateSoldOutBuses: {},
    rtcBuses: {},
    sortBy: 'best',
    rtcView: '',
    routeId:'',
    filters: {
      boardingPoints: {},
      droppingPoints: {},
      operators: {},
      amenities: {},
      collapsedFilter: ['boardingPoint', 'droppingPoint', 'operator', 'amenities'],
      collapsedFilterItemCount: 3,
      activeSearch: {type: '', val: ''},
      popularFilters:[],
      single_seat:false
    },
    selectedFilters: getInitSelectedFilters(),
    selectedBusIds:[],
    goSafeData:{},
    isRouteEnable:false,
    ps:'',
    alternate_route_data:[],
    next_day_bus:{},
    moveToAlternateRoutePage:false,
    nextDayPopup:false,
    srpCardIndex:'',
    adInventoryData:{},
    filter_cards:[]
  };
}

//TODO:- returning a new object each time with Object.assign instead of direct state manipulation
export default function SRP(state = getInitialState(), action) {
  const {type, actionData} = action;
  let filters = Object.assign({},state.filters);
     
  switch (type) {
    case CONSTANTS.TOGGLE_SRP_BUS_LOADING:
      return Object.assign({},state,{
        ...state,
        dataLoading:actionData
      })
    case CONSTANTS.UPDATE_SRP_BUS_DATA:
     filters.boardingPoints = actionData.bpList;
     filters.droppingPoints = actionData.dpList;
     filters.operators = actionData.operatorsList;
     filters.amenities = actionData.amenities;
     filters.popularFilters = actionData.popularFilters
     filters.single_seat = actionData?.single_seat;
      return Object.assign({},state,{
        ...state,
      rawData : actionData.data,
      privateAvailableBuses :actionData.privateAvailableBuses,
      rtcBuses : actionData.rtcBuses,
      filters:filters,
      isRouteEnable:actionData.isRouteEnable || false,
      ps:actionData.ps || '',
      alternate_route_data:actionData.alternate_route_data && actionData.alternate_route_data.length ? actionData.alternate_route_data : [],
      next_day_bus:actionData.next_day_bus && actionData.next_day_bus.no_of_bus ?  actionData.next_day_bus : {},
      filter_cards:actionData.filter_cards
     
      })
  
    case CONSTANTS.UPDATE_RTC_VIEW:
      return Object.assign({},state,{
        ...state,
        rtcView:actionData
      })
   
    case CONSTANTS.UPDATE_SORTBY:
      return Object.assign({},state,{
        ...state,
        sortBy:actionData
      })
   
    case CONSTANTS.RESET_FILTERS:
      if (actionData === 'resetAll') {
        return Object.assign({},state,{
          ...state,
          selectedFilters:getInitSelectedFilters(true)
        })
      } else {
       let selectedFilters = Object.assign({},state.selectedFilters);
       selectedFilters[actionData] = [];
 
        return Object.assign({},state,{
          ...state,
          selectedFilters:selectedFilters
        })
     
      }
    case CONSTANTS.FILTER_COLLAPSE:
      filters.collapsedFilter = addRemoveArrayOperation([...state.filters.collapsedFilter],actionData);
      return Object.assign({},state,{
        ...state,
        filters:filters
      })
    case CONSTANTS.UPDATE_ACTIVE_SEARCH_FILTER:
      filters.activeSearch.type = actionData.type;
      filters.activeSearch.val = actionData.val;
    
      return Object.assign({},state,{
        ...state,
        filters:filters
      })
    
    case CONSTANTS.UPDATE_SELECTED_FILTER:
      return Object.assign({},state,{
        ...state,
        selectedFilters:actionData
      })
    
    case CONSTANTS.UPDATE_SELECTED_BUS:
      if(!actionData){
        return Object.assign({},state,{
          ...state,
          selectedBusIds:[]
        })
        
      }
      return Object.assign({},state,{
        ...state,
        selectedBusIds:addRemoveArrayOperation([...state.selectedBusIds],actionData)
      })
    
    case CONSTANTS.UPDATE_GO_SAFE_BANNER:
      return Object.assign({},{
        ...state,
        goSafeData:actionData.data
      })
    case CONSTANTS.UPDATE_ROUTE_ID:
      return Object.assign({},{
        ...state,
        routeId:actionData
      })
     case CONSTANTS.TOGGLE_ALTERNATE_ROUTE_PAGE:
       return Object.assign({},{
         ...state,
         moveToAlternateRoutePage:actionData
       }) 
        case CONSTANTS.SET_NEXT_DAY_POPUP:
       return Object.assign({},{
         ...state,
         nextDayPopup:actionData
       }) 
     case CONSTANTS.SET_SRP_CARD_INDEX:
       return Object.assign({},{
         ...state,
         srpCardIndex:actionData
       }) 
    default:
      return state;
  }
}


